/** F6b serial numbers. */
export type SerialStatus = 'IN_STOCK' | 'ISSUED' | 'SOLD' | 'RETURNED' | 'REMOVED';

export const SERIAL_STATUSES: SerialStatus[] = ['IN_STOCK', 'ISSUED', 'SOLD', 'RETURNED', 'REMOVED'];

export interface SerialRow {
  id: string;
  serialNo: string;
  itemId: string;
  itemName?: string | null;
  itemCode?: string | null;
  storeId?: string | null;
  storeName?: string | null;
  status: SerialStatus;
  lastMovementAt?: string | null;
}

export interface SerialMovementRow {
  movement: string;
  occurredAt: string;
  fromStoreId?: string | null;
  fromStoreName?: string | null;
  toStoreId?: string | null;
  toStoreName?: string | null;
  /** Null when the caller lacks the source document's view key. */
  sourceType?: string | null;
  sourceId?: string | null;
  /** The document's number (GRN-…, DC-…), present only when the link is. */
  sourceNumber?: string | null;
  byUserName?: string | null;
}

export interface SerialDetail {
  serial: SerialRow;
  customerVisible: boolean;
  customerName?: string | null;
  challanNo?: string | null;
  history: SerialMovementRow[];
}

export interface SerialPage {
  content: SerialRow[];
  totalElements: number;
  page: number;
  size: number;
}

export interface SerialSearchFilter {
  q?: string;
  itemId?: string | null;
  storeId?: string | null;
  status?: SerialStatus | '' | null;
  page?: number;
  size?: number;
}

/** Body for posting a document with serials: line id -> serial numbers. */
export interface LineSerialsRequest {
  serials: Record<string, string[]>;
}

/** One serial a posted document moved (challan / transfer detail list them per line). */
export interface DocumentSerial {
  itemId: string;
  serialNo: string;
}
